export default __webpack_public_path__ + "static/media/zold-folt.6391a50f.png";